import { JsonClassType, JsonProperty, ObjectMapper } from "@outfoxx/jackson-js";
import {
    JsonParserContext
} from "@outfoxx/jackson-js/dist/@types";
import { Category } from "modules/construction-work/src/Entity/IniData/Category";
import { Status } from "modules/construction-work/src/Entity/IniData/Status";
import { Executor } from "modules/construction-work/src/Entity/IniData/Executor";
import { Group } from "modules/construction-work/src/Entity/IniData/Group";

export class IniData {
    @JsonProperty()
    @JsonClassType({ type: () => [Object, [String, Executor]] })
    executors: Record<string, Executor> = {};
    @JsonProperty()
    @JsonClassType({ type: () => [Object, [String, Category]] })
    categories: Record<string, Category> = {};
    @JsonProperty()
    @JsonClassType({ type: () => [Object, [String, Status]] })
    statuses: Record<string, Status> = {};
    @JsonProperty()
    @JsonClassType({ type: () => [Object, [String, Group]] })
    groups: Record<string, Group> = {};

    getExecutorsArray(): Executor[] {
        return Object.values(this.executors);
    }

    getCategoriesArray(): Category[] {
        return Object.values(this.categories);
    }

    getStatusesArray(): Status[] {
        return Object.values(this.statuses);
    }

    getGroupsArray(): Group[] {
        return Object.values(this.groups);
    }

    public static createByObj(object): IniData {
        if (!object) {
            throw new Error();
        }

        const objectMapper = new ObjectMapper();
        const context = { mainCreator: () => [IniData] } as JsonParserContext;

        return objectMapper.parse<IniData>(JSON.stringify(object), context);
    }
}
